import './DetailDescription.css'


function DetailDescription(props) {


    return (

        <div id='centerer'>


            <div id='detail-description'>
                <p style={{fontWeight: "bold"}}>Description:</p>
                <p>  {props.content}</p>

            </div>
            )

        </div>
    )


}

export default DetailDescription;